var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root-contrast" },
    [
      _c("route-name", { attrs: { propsRouteName: "智能文档比对" } }),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "contract" }, [
          _c("div", [
            _c("p", { staticStyle: { color: "#222" } }, [
              _vm._v("1.上传原文件/合同模板：")
            ]),
            _c(
              "div",
              { staticClass: "upload" },
              [
                _c("img", {
                  attrs: {
                    src: "/images/AISmart/icon/group.png",
                    width: "49px",
                    height: "47px",
                    alt: ""
                  }
                }),
                _c(
                  "el-upload",
                  {
                    ref: "originUpload",
                    staticClass: "upload-bth",
                    attrs: {
                      action: "#",
                      limit: 1,
                      "auto-upload": false,
                      "on-exceed": _vm.exceed,
                      accept: _vm.acceptType,
                      "on-change": _vm.changeOrigin,
                      "before-upload": _vm.originFileBeforeUpload
                    }
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "danger", plain: "" } },
                      [_vm._v("选择文件")]
                    )
                  ],
                  1
                ),
                _c("span", { staticStyle: { color: "#999" } }, [
                  _vm._v(
                    "可支持\n            " +
                      _vm._s(_vm.acceptType) +
                      " 格式文件，"
                  ),
                  _c("br"),
                  _vm._v("上传单个文件大小不超过30M。")
                ])
              ],
              1
            ),
            _c("div", { staticClass: "ignore-box" }, [
              _c(
                "p",
                [
                  _vm._v("\n            对比规则设置：\n            "),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { "true-label": 1, "false-label": 0 },
                      model: {
                        value: _vm.ignoreCheck,
                        callback: function($$v) {
                          _vm.ignoreCheck = $$v
                        },
                        expression: "ignoreCheck"
                      }
                    },
                    [_vm._v("忽略标点符号")]
                  )
                ],
                1
              )
            ])
          ]),
          _c("div", [
            _c("p", { staticStyle: { color: "#222" } }, [
              _vm._v("2. 上传第二文件/比对合同：")
            ]),
            _c(
              "div",
              { staticClass: "upload" },
              [
                _c("img", {
                  attrs: {
                    src: "/images/AISmart/icon/group.png",
                    width: "49px",
                    height: "47px",
                    alt: ""
                  }
                }),
                _c(
                  "el-upload",
                  {
                    ref: "targetUpload",
                    staticClass: "upload-bth",
                    attrs: {
                      action: "#",
                      limit: 1,
                      "auto-upload": false,
                      "on-exceed": _vm.exceed,
                      accept: _vm.acceptType,
                      "on-change": _vm.changeTarget,
                      "before-upload": _vm.targetFileChange
                    }
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "danger", plain: "" } },
                      [_vm._v("选择文件")]
                    )
                  ],
                  1
                ),
                _c("span", { staticStyle: { color: "#999" } }, [
                  _vm._v(
                    "可支持\n            " +
                      _vm._s(_vm.acceptType) +
                      " 格式文件，"
                  ),
                  _c("br"),
                  _vm._v("上传单个文件大小不超过30M。")
                ])
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "bontrast-btn" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "danger", loading: _vm.loading },
                on: { click: _vm.docContrast }
              },
              [_vm._v("开始对比")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-642b6164", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-642b6164","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/smartDoc/docContrast/contrast.vue
// module id = AxVr
// module chunks = 178